import { Box, Button, Hidden, Link, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ArrowBackIos } from "@material-ui/icons";
import { Link as RouteLink } from "react-router-dom";
import CloseSVG from "../assets/undraw_wip.svg";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(0.8),
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(1),
    },
    padding: theme.spacing(3),
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    // minHeight: "60vh"
  },
}));

function ClosedPage() {
  const classes = useStyles();

  return (
    <Box
      className={classes.root}
      display="flex"
      flexWrap="nowrap"
      alignItems="center"
    >
      <Hidden smDown>
        <Box width="100%" mr={4} maxWidth="250px">
          <img
            src={CloseSVG}
            style={{ width: "100%" }}
            alt="Work in Progress"
          />
        </Box>
      </Hidden>
      <Box
        display="flex"
        flexDirection="column"
        flexGrow="1"
        justifyContent="space-evenly"
      >
        <Box m={1}>
          {/* <Typography variant="h6" gutterBottom>
            Pools are under maintenance.
          </Typography> */}
          <Typography variant="h4" gutterBottom>
            Based on our community's valuable input, our pools are currently
            undergoing an upgrade 🙂
          </Typography>
          <Typography color="primary" variant="subtitle1">
            Thank you for your interest in the private alpha mainnet.
          </Typography>
          <br />
          <br />
          <Typography variant="body1" paragraph>
            You're welcome to contact us at&nbsp;
            <Link href="http://t.me/cyclosofficialchat" target="_blank">
              Telegram
            </Link>
            &nbsp;or&nbsp;
            <Link href="https://discord.gg/8TyZsDHAde" target="_blank">
              Discord
            </Link>
            &nbsp;for any queries and future updates.
          </Typography>
          <Typography variant="body1" paragraph>
            If you participated in the private alpha mainnet and still need to{" "}
            <strong> withdraw your funds</strong> and receive your reward,
            please fill out this form here:
          </Typography>

          <br />
          <Button
            variant="contained"
            className="reset-text"
            onClick={() =>
              window.open(
                "https://docs.google.com/forms/d/e/1FAIpQLScSinpyxCFTfaSIYJYOKgpoFTvgviM7AX3UF2Iqjrb8O7ytMw/viewform"
              )
            }
          >
            Feedback Form
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default ClosedPage;

// or contact us
// at&nbsp;
// <Link href="http://t.me/cyclosofficialchat" target="_blank">
//   Telegram&nbsp;
// </Link>
// or&nbsp;
// <Link href="https://discord.gg/8TyZsDHAde" target="_blank">
//   Discord&nbsp;
// </Link>
// and tweet at us&nbsp;
// <Link href="https://twitter.com/cyclosfi" target="_blank">
//   @cyclosfi
// </Link>
